export type Salary = FixedSalary | SalaryRange

interface BaseSalary {
  id?: string
  nodeName?: string
  nodeId?: string | number
  currency: string
  periodicity: string
  workplaces?: Workplace[]
}

export interface FixedSalary extends BaseSalary {
  gross: number // in cents
  min?: never
  max?: never
}

export interface SalaryRange extends BaseSalary {
  gross?: never
  min: number // in cents
  max: number // in cents
}

export interface Workplace {
  id: string
  name: string
}

export const SalaryPeriodicity = {
  yearly: 'yearly',
  monthly: 'monthly',
  weekly: 'weekly',
  daily: 'daily',
  hourly: 'hourly',
}
